// Child Component of: 
// --- BaseBlock

// Import React and Material-UI Modules
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Input from '@material-ui/core/Input';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Slider from '@material-ui/core/Slider';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { ACTION_GROUP_REF_MAP, ACTION_GROUP_STRINGS, POSE_GROUP_REF_MAP, POSE_GROUP_STRINGS, RGB_STYLE_REF_MAP, RGB_STYLE_STRINGS } from '../../../libraries/LocoHex/LocoHex';

// Material-UI CSS-type Style Specifications
const styles = (theme) => ({
    paper: {
      width: 515,//600
      height: 200,
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      square: false,
      boxShadow: theme.shadows[5],
    },
    grid: {
        justify: 'flex-start',
    },
    gridWhite: {
        justify: 'flex-start',
        backgroundColor: 'white',
        borderRadius: '15px',
        padding: theme.spacing(1),
    },
    titleText: {
        color: "white",
        margin: theme.spacing(1),
    },
    inputField: {
        width: "100%",
        color: "white",
        marginTop: theme.spacing(0.6),
        marginLeft: theme.spacing(1),
        textAlign: "center",
    },
    inputFieldRC: {
        width: "100%",
        color: "white",
        marginTop: theme.spacing(0.6),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        textAlign: "center",
    },
    regularText: {
        color: "white",
        margin: theme.spacing(1),
    },
    textButton: {
        color: "white",
        margin: theme.spacing(0),
        border: '1px solid #000',
    },
    colorDisplay: {
        margin: '7px',
        height: '25px',
        width: '50px',
        borderRadius: '5px',
        border: '1px solid #000',
    },
    textSelect: {
        color: "white",
        marginTop: theme.spacing(0.4),        
    },
});




// Component Class
class LocoHexBlocks extends React.Component {

    constructor(props) {
        super(props);
        
    }


    state = {
        LBlocksOptions: {
            itravel: 
            {
                id: 0,
                title: 'Travel',
                height: 115, 
                color: '#4DAF4E',
                control: {
                    sel1: 'locohex.FORWARD_SMALL_STEP_LOW', sel1Txt: 'FORWARD', 
                    //btn2: 'locohex.Iteration', btn2Txt: 'ITERATIONS',
                    in1: 1, 
                },
                codeRef(ctrl) {

                    const travel_type = `${ctrl.sel1}`; // e.g., locohex.FORWARD_SMALL_STEP_LOW
                    
                    let value = ctrl.in1 * 1000;// Convert seconds to milliseconds
                    const comment = `# Travel ${ctrl.sel1Txt} for ${ctrl.in1} second(s)}`;

                    return [
                        comment, 
                        `locohex.set_travel(${travel_type}, locohex.Timed, ${value})`,
                    ]
                },
                code: [],
                sel1Options: [
                    'FORWARD', 'BACKWARD', 'TURN LEFT', 'TURN RIGHT', 'SLIDE LEFT', 'SLIDE RIGHT'
                ],
                sel1map: {
                    'FORWARD': 'locohex.FORWARD_SMALL_STEP_LOW',
                    'BACKWARD': 'locohex.BACKWARD_SMALL_STEP_LOW',
                    'TURN LEFT': 'locohex.TURN_LEFT_SMALL_STEP_LOW',
                    'TURN RIGHT': 'locohex.TURN_RIGHT_SMALL_STEP_LOW',
                    'SLIDE LEFT': 'locohex.SLIDE_LEFT',
                    'SLIDE RIGHT': 'locohex.SLIDE_RIGHT',
                },
                inWidth: '40px',
                in1Type: 'float',
                in1Limits: [0, 30],
                //in1LimitsOpts: {'SECONDS': [0, 10], 'ITERATIONS': [1, 10]},
                //in1LimitsOptsSrc: 'btn2Txt',
                //in1TypeOpts: {'SECONDS': 'float', 'ITERATIONS': 'int'},
                //in1TypeOptsSrc: 'btn2Txt',
                text1: 'Travel ',
                text2: 'for ',
                text3: 'second(s)'
            },
            iaction:
            {
                id: 0,
                title: 'Action',
                height: 110, 
                color: '#FF2424',
                control: {
                    sel1: ACTION_GROUP_REF_MAP[ACTION_GROUP_STRINGS[0]], 
                    sel1Txt: ACTION_GROUP_STRINGS[0], 
                },
                codeRef(ctrl) {
                    const action_type = `${ctrl.sel1}`; // e.g., locohex.FORWARD_SMALL_STEP_LOW

                    const comment = `# Perform ${ctrl.sel1Txt}`;
                    return [
                        comment, 
                        `locohex.set_action(${action_type})`//, locohex.Iteration, 1)`,
                    ]
                },
                code: [],
                sel1Options: ACTION_GROUP_STRINGS,
                btn2Options: [
                    'ITERATIONS', 'SECONDS',
                ],
                sel1map: ACTION_GROUP_REF_MAP,
                btn2map: {
                    'ITERATIONS': 'locohex.Iteration',
                    'SECONDS': 'locohex.Timed',
                },
                inWidth: '40px',
                //in1Type: 'int',
                //in1Limits: [0, 10],
                in1LimitsOpts: {'SECONDS': [0, 10], 'ITERATIONS': [1, 10]},
                in1LimitsOptsSrc: 'btn2Txt',
                in1TypeOpts: {'SECONDS': 'float', 'ITERATIONS': 'int'},
                in1TypeOptsSrc: 'btn2Txt',
                text1: 'Perform ',
            },
            imatrix: {
                id: 0,
                title: 'Matrix',
                height: 200, 
                color: '#F542EC',
                control: {
                    btn1: 'locohex.Static', btn1Text: "Static", 
                    slid1: 3,
                    in1: 'A', 
                    in2: 0.5, 
                    mode: 'Set String', modeIndex: 2,
                },
                codeRef(ctrl) {
                    let codeArray = [];
                    if (ctrl.mode === 'Set Brightness') {
                        codeArray.push(`# Set Matrix Brightness to ${ctrl.slid1}`)
                        codeArray.push(`locohex.set_matrix_brightness(${ctrl.slid1})`)
                    } else if (ctrl.mode === 'Clear Screen') {
                        codeArray.push("# Clear Matrix Screen")
                        codeArray.push(`locohex.clear_matrix()`)
                    } else if (ctrl.mode === 'Set String') {
                        codeArray.push(`# Set Matrix to String ${ctrl.in1} as ${ctrl.btn1Txt}`)
                        if (ctrl.btn1Txt === 'Scrolling') {
                            const scrollMs = ctrl.in2 * 1000; // Convert seconds to milliseconds
                            codeArray.push(`locohex.set_matrix('${ctrl.in1}', ${ctrl.btn1}, ${scrollMs})`)
                        } else {
                            codeArray.push(`locohex.set_matrix('${ctrl.in1}', ${ctrl.btn1})`)
                        }
                    }
                    return codeArray;
                },
                code: [],
                btn1Options: ['Static', 'Scrolling'],
                btn1map: {'Static':'locohex.Static', 'Scrolling': 'locohex.Scrolling'},
                modeOptions: ['Set Brightness', 'Clear Screen', 'Set String'],
                modeIndices: 3,
                heightMode: {'Set Brightness': 125, 'Clear Screen': 115, 'Set String': 165},
                text1s: 'Set Matrix String to',
                text1b: 'Set Matrix Brightness to',
                text1c: 'Clear Matrix Screen',
                text2: 'as',
                text3: 'every',
                text4: 'second(s)',
                inWidth: '150px',
                in2Width: '40px',
                in1Type: 'text',
                in2Type: 'float',
                in1Limits: [1, 16],
                in2Limits: [0.1, 2],
            },
            irgb: {
                id: 0,
                title: 'Color',
                height: 200, 
                color: '#DE7A00',
                control: {
                    slid1: 0, slid2: 255, slid3: 0, 
                    slid4: 0, slid5: 255, slid6: 0,
                    mode: 'Standard', modeIndex: 0,
                },
                codeRef(ctrl) {
                    const rgb1 = `[${ctrl.slid1}, ${ctrl.slid2}, ${ctrl.slid3}]`;
                    const rgb2 = `[${ctrl.slid4}, ${ctrl.slid5}, ${ctrl.slid6}]`;
                    const mode = ctrl.mode; // e.g., Standard
                    const comment =
                        mode === 'Standard'
                            ? `# Set RGB LEDs to [${ctrl.slid1}, ${ctrl.slid2}, ${ctrl.slid3}] and [${ctrl.slid4}, ${ctrl.slid5}, ${ctrl.slid6}] in Standard style`
                            : `# Set RGB Breathing Pulse Rates to [${ctrl.slid1}, ${ctrl.slid2}, ${ctrl.slid3}] and [${ctrl.slid4}, ${ctrl.slid5}, ${ctrl.slid6}]`
                    return [
                        comment, 
                        `locohex.set_rgbs(${rgb1}, ${rgb2}, locohex.${mode})`,
                    ]
                },
                code: [],
                in1Width: '40px',
                in1Type: 'float',
                text1: {
                    'Standard':'Set RGB Colors',
                    'Breathing':'Set RGB Breathing Pulse Rates',
                },
                clrBox1H: '70px',
                clrBox1W: '20px',
                modeOptions: ['Standard', 'Breathing'],
                modeIndices: 2,
                heightMode: {'Standard': 200, 'Breathing': 200},
                slidMode: {'Standard': 255, 'Breathing': 50},
                slidSrcs: ['slid1', 'slid2', 'slid3', 'slid4', 'slid5', 'slid6'],
            },
            ipose: 
            {
                id: 0,
                title: 'Pose',
                height: 115, 
                color: '#009788',
                control: {
                    sel1: POSE_GROUP_REF_MAP[POSE_GROUP_STRINGS[0]], 
                    sel1Txt: POSE_GROUP_STRINGS[0]
                },
                codeRef(ctrl) {
                    return [
                        `# Set ${ctrl.sel1Txt}`, 
                        `locohex.set_pose(${ctrl.sel1})`,
                    ]
                },
                code: [],
                sel1Options: POSE_GROUP_STRINGS,
                sel1map: POSE_GROUP_REF_MAP,
                text1: 'Set ',
            },
            iloop:
            {
                id: 0,
                title: 'Loop',
                height: 115, 
                color: '#8057c1',
                control: {in1: 0, },
                codeRef(ctrl) {
                    return [`# Loop for ${ctrl.in1} times`, `for i in range(${ctrl.in1}):`]
                },
                code: [],
                inWidth: '40px',
                in1Type: 'int',
                text1: 'Repeat',
                text2: 'times',
            },
            iloopend:
            {        
                id: 0,
                title: 'LoopEnd',
                height: 115, 
                color: '#8057c1',
                control: {},
                code: [],
            },
            ipause:
            {
                id: 0,
                title: 'Pause',
                height: 115, 
                color: '#fbc22d',
                control: {in1: 0, },
                codeRef(ctrl) {
                    return [`# Pause for ${ctrl.in1} second(s)`, `time.sleep(${ctrl.in1})`]
                },
                code: [],
                inWidth: '40px',
                in1Type: 'float',
                text1: 'Pause for',
                text2: 'second(s)',
                in1Limits: [0, 60],
            },
        },
        renderType: this.props.blockType,
        btn1: 0,
        btn2: 0,
        btn3: 0,
        btn4: 0,
        btn1Txt: '',
        btn2Txt: '',
        btn3Txt: '',
        btn4Txt: '',
        in1: 0,
        in2: 0,
        in3: 0,
        in4: 0,
        sel1Txt: '',
        sel2Txt: '',
        sel1: 0,
        sel2: 0,
        slid1: 255,
        slid2: 255,
        slid3: 255,
        slid4: 255,
        slid5: 255,
        slid6: 255,
        mode: '',
    }

    componentDidMount() {
        
        let updates = {control: this.props.control};
        this.componentRefresh(updates);
    }

    componentRefresh = (updates) => {
        
        let tempRenderType = this.state.renderType;
        
        if ('name' in updates) {
            tempRenderType = updates.name;
            this.setState( {renderType: updates.name} );
        }
        let tempLBlocks = { ...this.state.LBlocksOptions };
        tempLBlocks[tempRenderType].id = this.props.id
        if ((typeof updates.control !== "undefined") && (Object.keys(updates.control).length !== 0)) {
            let keyNames = Object.keys(updates.control);
            keyNames.forEach((val, i) => {
                tempLBlocks[tempRenderType].control[val] = updates.control[val];
                this.setState( {[val]: updates.control[val]} );
                if (tempLBlocks[tempRenderType].hasOwnProperty('codeRef')) {
                    tempLBlocks[tempRenderType].code = tempLBlocks[tempRenderType].codeRef(tempLBlocks[tempRenderType].control);
                }
            });
        } else {
            if (tempLBlocks[tempRenderType].hasOwnProperty('codeRef')) {
                tempLBlocks[tempRenderType].code = tempLBlocks[tempRenderType].codeRef(tempLBlocks[tempRenderType].control);
            }
            const controls = [
                'btn1', 'btn2', 'btn3', 'btn4',
                'in1', 'in2', 'in3', 'in4', 
                'sel1', 'sel2', 
                'slid1', 'slid2', 'slid3', 'slid4', 'slid5', 'slid6',
                'mode'
            ];

            controls.forEach(control => {
                if (control in tempLBlocks[tempRenderType].control) {
                    if (control.startsWith('btn')) {
                        const optionKey = `${control}Options`;
                        const mapKey = `${control}map`;
                        tempLBlocks[tempRenderType].control[control] = tempLBlocks[tempRenderType][mapKey][tempLBlocks[tempRenderType][optionKey][0]];
                        tempLBlocks[tempRenderType].control[`${control}Txt`] = tempLBlocks[tempRenderType][optionKey][0];
                        this.setState({ [`${control}Txt`]: tempLBlocks[tempRenderType].control[`${control}Txt`] });
                    } else if (control.startsWith('in')) {
                        this.setState({ [control]: tempLBlocks[tempRenderType].control[control] });
                    } else if (control.startsWith('slid')) {
                        this.setState({ [control]: tempLBlocks[tempRenderType].control[control] });
                    } else if (control.startsWith('sel')) {
                        const optionKey = `${control}Options`;
                        tempLBlocks[tempRenderType].control[`${control}Txt`] = tempLBlocks[tempRenderType][optionKey][0];
                        this.setState({ [`${control}Txt`]: tempLBlocks[tempRenderType].control[`${control}Txt`] });
                    } else if (control.startsWith('mode')) {
                        this.setState( {mode: tempLBlocks[tempRenderType].control.mode} );
                    }
                }
            });
        }
        if (tempLBlocks[tempRenderType].hasOwnProperty('heightMode')) {
            tempLBlocks[tempRenderType].height = 
                tempLBlocks[tempRenderType].heightMode[tempLBlocks[tempRenderType].control.mode]
        }
        
        this.setState( {LBlocksOptions: tempLBlocks} );
        this.props.handleSubState(tempLBlocks[tempRenderType]);
    }

    handleInOnBlur = (event, name) => {
        if (!this.state.hasOwnProperty(name)) {
            return
        }
        let m = this.state[name]
        let inName = name

        let inLimits = inName + 'Limits'
        let inCust = inName + 'Cust'
        let inType = inName + "Type"

        const inLimitsOpts = inName + "LimitsOpts"
        const inLimitsOptsSrc = inName + "LimitsOptsSrc"
        const inTypeOpts = inName + "TypeOpts"
        const inTypeOptsSrc = inName + "TypeOptsSrc"

        let tempLBlocks = this.state.LBlocksOptions;

        let inTypeRef = null;
        if (!(inLimits in tempLBlocks[this.state.renderType])) {
            // inLimits does not exist in tempLBlocks[this.state.renderType]
            inTypeRef = inTypeOpts[tempLBlocks[this.state.renderType].control[
                tempLBlocks[this.state.renderType][inTypeOptsSrc]
            ]];
        } else {
            inTypeRef = tempLBlocks[this.state.renderType][inType];
        }
        if (!isNaN(parseFloat(m)) && isFinite(m)) {
            let n = Number(m);
            
            if (inLimits in tempLBlocks[this.state.renderType]) {
                if (n < tempLBlocks[this.state.renderType][inLimits][0]) {
                    if (tempLBlocks[this.state.renderType][inLimits][0] < 0) {
                        n = 0
                        m = "0"
                    } else {
                        n = tempLBlocks[this.state.renderType][inLimits][0]
                        m = String(tempLBlocks[this.state.renderType][inLimits][0])
                    }
                } else if (n > tempLBlocks[this.state.renderType][inLimits][1]) {
                    n = tempLBlocks[this.state.renderType][inLimits][1]
                    m = String(tempLBlocks[this.state.renderType][inLimits][1])
                }
            } else if (inCust in tempLBlocks[this.state.renderType]) {
                n = tempLBlocks[this.state.renderType].boundRef(n)
                m = String(n)
            } else if (inLimitsOpts in tempLBlocks[this.state.renderType]) {
                const limitsOpts = tempLBlocks[this.state.renderType][inLimitsOpts];
                const limits = limitsOpts[tempLBlocks[this.state.renderType].control[
                    tempLBlocks[this.state.renderType][inLimitsOptsSrc]
                ]];
                
                n = Math.max(limits[0], Math.min(n, limits[1]));
                m = String(n);
            }
            if (inTypeRef === 'int') {
                tempLBlocks[this.state.renderType].control[inName] = Math.floor(n);
                m = String(Math.floor(n))
                tempLBlocks[this.state.renderType].code = tempLBlocks[this.state.renderType].codeRef(tempLBlocks[this.state.renderType].control);
            } else {
                tempLBlocks[this.state.renderType].control[inName] = n;
                tempLBlocks[this.state.renderType].code = tempLBlocks[this.state.renderType].codeRef(tempLBlocks[this.state.renderType].control);
            }
        } else {
            if (inTypeRef !== 'text') {
                if (inLimits in tempLBlocks[this.state.renderType]) {
                    if (tempLBlocks[this.state.renderType][inLimits][0] < 0) {
                        m = "0"
                    } else {
                        m = String(tempLBlocks[this.state.renderType][inLimits][0])
                    }
                } else {
                    m = "0"
                }
            } else {
                if (inLimits in tempLBlocks[this.state.renderType]) {
                    // For text input, enforce string length limits
                    const minLen = tempLBlocks[this.state.renderType][inLimits][0];
                    const maxLen = tempLBlocks[this.state.renderType][inLimits][1];
                    if (typeof m === 'string') {
                        if (m.length < minLen) {
                            m = m.padEnd(minLen, 'A');
                        } else if (m.length > maxLen) {
                            m = m.substring(0, maxLen);
                        }
                    }
                }
            }
            tempLBlocks[this.state.renderType].control[inName] = m;
            tempLBlocks[this.state.renderType].code = tempLBlocks[this.state.renderType].codeRef(tempLBlocks[this.state.renderType].control);
        }
        
        this.setState( {LBlocksOptions: tempLBlocks, [name]: m} );
        this.props.handleSubState(tempLBlocks[this.state.renderType]);
    }

    handleIn = (event) => {
        let m = event.target.value;
        this.setState( {[event.target.name]: m} );
    }
    
    handleBtn = (num) => {

        let numStr = String(num);
        let btnMap = 'btn' + numStr + 'map'
        let btnOptions = 'btn' + numStr + 'Options'
        let btnName = 'btn' + numStr
        let btnText = 'btn' + numStr + 'Txt'

        let tempLBlocks = this.state.LBlocksOptions;

        let nowIndex = tempLBlocks[this.state.renderType][btnOptions].indexOf(tempLBlocks[this.state.renderType].control[btnText])
        nowIndex += 1
        if (nowIndex >= tempLBlocks[this.state.renderType][btnOptions].length) {
            nowIndex = 0
        }
        tempLBlocks[this.state.renderType].control[btnName] = 
            tempLBlocks[this.state.renderType][btnMap][tempLBlocks[this.state.renderType][btnOptions][nowIndex]];

        if (btnMap in tempLBlocks[this.state.renderType]) {
            tempLBlocks[this.state.renderType].control[btnText] = tempLBlocks[this.state.renderType][btnOptions][nowIndex];
            this.setState( {[btnText]: tempLBlocks[this.state.renderType].control[btnText]} );
        } else {
            this.setState( {[btnText]: tempLBlocks[this.state.renderType].control[btnName]} );
        }

        // cheating, isn't dynamic if other than in1 has dependent limits
        if (tempLBlocks[this.state.renderType].hasOwnProperty('in1LimitsOpts')) {
            if (tempLBlocks[this.state.renderType]['in1LimitsOptsSrc'] === btnText) {
                let inLimitsOpts = tempLBlocks[this.state.renderType]['in1LimitsOpts'];
                let limits = inLimitsOpts[tempLBlocks[this.state.renderType].control[btnText]];

                if (tempLBlocks[this.state.renderType].control.in1 < limits[0]) {
                    tempLBlocks[this.state.renderType].control.in1 = limits[0];
                    this.setState( {in1: limits[0]} );
                } else if (tempLBlocks[this.state.renderType].control.in1 > limits[1]) {
                    tempLBlocks[this.state.renderType].control.in1 = limits[1];
                    this.setState( {in1: limits[1]} );
                }
            }
        }



        tempLBlocks[this.state.renderType].code = tempLBlocks[this.state.renderType].codeRef(tempLBlocks[this.state.renderType].control);
        
        this.setState( {LBlocksOptions: tempLBlocks} );
        this.props.handleSubState(tempLBlocks[this.state.renderType]);
    }

    handleSelect = (event) => {

        let hName = event.target.name;
        let hText = hName + 'Txt';
        let hMap = hName + 'map';

        let tempLBlocks = this.state.LBlocksOptions;
        if (hMap in tempLBlocks[this.state.renderType]) {
            tempLBlocks[this.state.renderType].control[hName] = tempLBlocks[this.state.renderType][hMap][event.target.value];                
            tempLBlocks[this.state.renderType].control[hText] = event.target.value;

            this.setState( {[hText]: tempLBlocks[this.state.renderType].control[hText]} );
        }
        
        tempLBlocks[this.state.renderType].code = tempLBlocks[this.state.renderType].codeRef(tempLBlocks[this.state.renderType].control);
        
        this.setState( {LBlocksOptions: tempLBlocks} );
        this.props.handleSubState(tempLBlocks[this.state.renderType]);
    }

    handleSlider = (event, value, name) => {
        
        this.setState({[name]: value});
        
        let tempLBlocks = this.state.LBlocksOptions;
        
        tempLBlocks[this.state.renderType].control[name] = value

        tempLBlocks[this.state.renderType].code = tempLBlocks[this.state.renderType].codeRef(tempLBlocks[this.state.renderType].control);

        this.setState( {LBlocksOptions: tempLBlocks} );
        this.props.handleSubState(tempLBlocks[this.state.renderType]);
    }

    handleMode = (event, name) => {

        let tempLBlocks = this.state.LBlocksOptions;

        tempLBlocks[this.state.renderType].control.modeIndex++;
        if (tempLBlocks[this.state.renderType].control.modeIndex >= tempLBlocks[this.state.renderType].modeIndices) {
            tempLBlocks[this.state.renderType].control.modeIndex = 0;
        }

        tempLBlocks[this.state.renderType].control.mode = tempLBlocks[this.state.renderType].modeOptions[tempLBlocks[this.state.renderType].control.modeIndex];
        
        if (tempLBlocks[this.state.renderType].hasOwnProperty('slidMode')) {
            //slidMode: {'Standard': 255, 'Breathing': 50},
            const slidLim = tempLBlocks[this.state.renderType].slidMode[tempLBlocks[this.state.renderType].control.mode]
            //slidSrcs
            tempLBlocks[this.state.renderType].slidSrcs.forEach((src) => {
                if (tempLBlocks[this.state.renderType].control[src] > slidLim) {
                    tempLBlocks[this.state.renderType].control[src] = slidLim;
                    this.setState({[src]: slidLim});
                }
            });
        }
        
        tempLBlocks[this.state.renderType].code = tempLBlocks[this.state.renderType].codeRef(tempLBlocks[this.state.renderType].control);

        if (tempLBlocks[this.state.renderType].hasOwnProperty('heightMode')) {
            tempLBlocks[this.state.renderType].height = 
            tempLBlocks[this.state.renderType].heightMode[tempLBlocks[this.state.renderType].control.mode]
        }

        //this.forceBoundCheck(tempLBlocks)

        this.setState( {LBlocksOptions: tempLBlocks, mode: tempLBlocks[this.state.renderType].control.mode} );
        this.props.handleSubState(tempLBlocks[this.state.renderType]);
    }

    render() {

        // Referenced below for setting styles
        const { classes } = this.props;

        return (
            <React.Fragment>
                <Box 
                    height={this.state.LBlocksOptions[this.state.renderType].height}
                    style={{backgroundColor: this.state.LBlocksOptions[this.state.renderType].color}}
                >
                    {this.state.LBlocksOptions[this.state.renderType]?.title ? (
                        <Typography 
                            className={classes.titleText}
                            variant='h4'
                            style={{backgroundColor: this.state.LBlocksOptions[this.state.renderType].color}}
                        >
                            {`[${this.props.isDisabled ? this.props.i : this.props.i + 1}]: 
                                ${this.state.LBlocksOptions[this.state.renderType].title}`}
                        </Typography>
                    ) : (
                        <div style={{ paddingTop: '8px' }}></div> // Add padding when there is no title
                    )}
                    {((this.state.renderType === 'iloop') || 
                        (this.state.renderType === 'ipause')) && (
                        <Grid 
                            container 
                            spacing={0}
                            className={classes.grid}
                            direction="row"
                        >
                        <Grid item xs="auto">
                            <Typography 
                                className={classes.regularText}
                                style={{backgroundColor: this.state.LBlocksOptions[this.state.renderType].color}}
                            >
                                {this.state.LBlocksOptions[this.state.renderType].text1}
                            </Typography>
                        </Grid>
                        <Grid item xs="auto">
                            <Input 
                                className={classes.inputField}
                                name='in1'
                                style={{
                                    width: this.state.LBlocksOptions[this.state.renderType].inWidth,
                                  }}
                                onChange = {this.handleIn}
                                onBlur = {(e) => this.handleInOnBlur(e, 'in1')}
                                value={this.state.in1}
                                disabled={this.props.isDisabled}
                                autoComplete="off"
                            />
                        </Grid>
                        <Grid item xs="auto">
                            <Typography 
                                className={classes.regularText}
                                style={{backgroundColor: this.state.LBlocksOptions[this.state.renderType].color}}
                            >
                                {this.state.LBlocksOptions[this.state.renderType].text2}
                            </Typography>
                        </Grid>
                        </Grid>
                    )}
                    {(this.state.renderType === 'itravel') && (
                        <Grid 
                            container 
                            spacing={0}
                            className={classes.grid}
                            direction="row"
                        >
                        <Grid item xs="auto">
                            <Select
                                className={classes.textSelect}
                                style={{backgroundColor:this.state.LBlocksOptions[this.state.renderType].color}}
                                onClick={this.handleSelect}
                                disabled={this.props.isDisabled}
                                name='sel1'
                                value={this.state.sel1Txt}
                            >
                            {this.state.LBlocksOptions[this.state.renderType].sel1Options.map((val) => {
                                return (
                                    <MenuItem 
                                        key = {'sel1' + val} 
                                        value = {val}
                                        style={{backgroundColor:this.state.LBlocksOptions[this.state.renderType].color, color: "white"}}
                                    >{val}</MenuItem>
                                );
                            })}
                            </Select>
                        </Grid>
                        <Grid item xs="auto">
                            <Typography 
                                className={classes.regularText}
                                style={{backgroundColor: this.state.LBlocksOptions[this.state.renderType].color}}
                            >
                                {this.state.LBlocksOptions[this.state.renderType].text2}
                            </Typography>
                        </Grid>
                        <Grid item xs="auto">
                            <Input 
                                className={classes.inputField}
                                name='in1'
                                style={{
                                        width: this.state.LBlocksOptions[this.state.renderType].inWidth,
                                        marginRight: '5px',
                                    }}
                                onChange = {this.handleIn}
                                onBlur = {(e) => this.handleInOnBlur(e, 'in1')}
                                value={this.state.in1}
                                disabled={this.props.isDisabled}
                                autoComplete="off"
                            />
                        </Grid>
                        <Grid item xs="auto">
                            <Typography 
                                className={classes.regularText}
                                style={{backgroundColor: this.state.LBlocksOptions[this.state.renderType].color}}
                            >
                                {this.state.LBlocksOptions[this.state.renderType].text3}
                            </Typography>
                        </Grid>
                        </Grid>
                    )}
                    {(this.state.renderType === 'iaction') && (
                        <Grid 
                            container 
                            spacing={0}
                            className={classes.grid}
                            direction="row"
                        >
                        <Grid item xs="auto">
                            <Typography 
                                className={classes.regularText}
                                style={{backgroundColor: this.state.LBlocksOptions[this.state.renderType].color}}
                            >
                                {this.state.LBlocksOptions[this.state.renderType].text1}
                            </Typography>
                        </Grid>
                        <Grid item xs="auto">
                            <Select
                                className={classes.textSelect}
                                style={{backgroundColor:this.state.LBlocksOptions[this.state.renderType].color}}
                                onClick={this.handleSelect}
                                disabled={this.props.isDisabled}
                                name='sel1'
                                value={this.state.sel1Txt}
                            >
                            {this.state.LBlocksOptions[this.state.renderType].sel1Options.map((val) => {
                                return (
                                    <MenuItem 
                                        key = {'sel1' + val} 
                                        value = {val}
                                        style={{backgroundColor:this.state.LBlocksOptions[this.state.renderType].color, color: "white"}}
                                    >{val}</MenuItem>
                                );
                            })}
                            </Select>
                        </Grid>
                        </Grid>
                    )}
                    {(this.state.renderType === 'ipose') && (
                        <Grid 
                            container 
                            spacing={0}
                            className={classes.grid}
                            direction="row"
                        >
                        <Grid item xs="auto">
                            <Typography 
                                className={classes.regularText}
                                style={{backgroundColor: this.state.LBlocksOptions[this.state.renderType].color}}
                            >
                                {this.state.LBlocksOptions[this.state.renderType].text1}
                            </Typography>
                        </Grid>
                        <Grid item xs="auto">
                            <Select
                                className={classes.textSelect}
                                style={{backgroundColor:this.state.LBlocksOptions[this.state.renderType].color}}
                                onClick={this.handleSelect}
                                disabled={this.props.isDisabled}
                                name='sel1'
                                value={this.state.sel1Txt}
                            >
                            {this.state.LBlocksOptions[this.state.renderType].sel1Options.map((val) => {
                                return (
                                    <MenuItem 
                                        key = {'sel1' + val} 
                                        value = {val}
                                        style={{backgroundColor:this.state.LBlocksOptions[this.state.renderType].color, color: "white"}}
                                    >{val}</MenuItem>
                                );
                            })}
                            </Select>
                        </Grid>
                        </Grid>
                    )}
                    {(this.state.renderType === 'irgb') && (
                        <Grid 
                            container 
                            spacing={0}
                            className={classes.grid}
                            direction="row"
                        >
                        <Grid item xs={12}>
                            <Grid 
                                container 
                                spacing={0}
                                direction="row"
                            >
                            <Grid item xs={12} style={{position:'relative', top:'-35px',}}>
                                <Box display="flex" flexDirection="row-reverse">
                                <Button
                                    className={classes.textButton}
                                    style={{backgroundColor:this.state.LBlocksOptions[this.state.renderType].color}}
                                    variant="contained"
                                    onClick={(e) => this.handleMode(e, 'mode')}
                                    disabled={this.props.isDisabled}
                                >
                                    {this.state.mode}
                                </Button>
                                </Box>
                            </Grid>
                            <Grid item xs= {12} style = {{marginTop: '-30px'}}>
                                <Typography 
                                    className={classes.regularText}
                                    style={{backgroundColor: this.state.LBlocksOptions[this.state.renderType].color}}
                                >
                                    {this.state.LBlocksOptions[this.state.renderType].text1[this.state.mode]}
                                </Typography>
                            </Grid>
                            <Grid item xs= {6}>
                                <Box
                                    style = {{backgroundColor: "white", 
                                            margin: 1, 
                                            borderRadius: 15}}
                                >
                                    <Grid 
                                        container 
                                        spacing={0}
                                        justifyContent = "space-around"
                                        alignItems = "center"
                                        direction="row"
                                    >
                                        <Grid item xs={3}>
                                            {this.state.mode === 'Standard' && (
                                                <Box
                                                    style={{
                                                        backgroundColor: `rgb(${this.state.slid1}, 
                                                                            ${this.state.slid2},
                                                                            ${this.state.slid3})`,
                                                        borderRadius: 15,
                                                        border: '1px solid black',
                                                        minWidth: this.state.LBlocksOptions[this.state.renderType].clrBox1W,
                                                        minHeight: this.state.LBlocksOptions[this.state.renderType].clrBox1H,
                                                        margin: '5px',
                                                    }}
                                                />
                                            )}
                                        </Grid>
                                        <Grid item xs={this.state.mode === 'Standard' ? 9 : 12}>
                                            <Box 
                                                style = {{
                                                    paddingLeft: '8px', paddingRight: '8px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'center',
                                                    height: '60px',
                                                    margin: '10px',
                                                }}
                                            >
                                                <Slider
                                                    defaultValue={255}
                                                    aria-labelledby="discrete-slider"
                                                    valueLabelDisplay="auto"
                                                    value={this.state.slid1}
                                                    style={{
                                                        color:"rgb(255, 0, 0)",
                                                        marginTop: '0px'
                                                    }}
                                                    step={1}
                                                    min={0}
                                                    max={this.state.mode === 'Standard' ? 255 : 50}
                                                    disabled={this.props.isDisabled}
                                                    onChange={(event, value) => this.handleSlider(event, value, 'slid1')}
                                                />
                                                <Slider
                                                    defaultValue={255}
                                                    aria-labelledby="discrete-slider"
                                                    valueLabelDisplay="auto"
                                                    value={this.state.slid2}
                                                    style={{
                                                        color:"rgb(0, 255, 0)",
                                                        marginTop: '-10px',
                                                    }}
                                                    step={1}
                                                    min={0}
                                                    max={this.state.mode === 'Standard' ? 255 : 50}
                                                    disabled={this.props.isDisabled}
                                                    onChange={(event, value) => this.handleSlider(event, value, 'slid2')}
                                                />
                                                <Slider
                                                    defaultValue={255}
                                                    aria-labelledby="discrete-slider"
                                                    valueLabelDisplay="auto"
                                                    value={this.state.slid3}
                                                    style={{
                                                        color:"rgb(0, 0, 255)",
                                                        marginTop: '-10px',
                                                    }}
                                                    step={1}
                                                    min={0}
                                                    max={this.state.mode === 'Standard' ? 255 : 50}
                                                    disabled={this.props.isDisabled}
                                                    onChange={(event, value) => this.handleSlider(event, value, 'slid3')}
                                                />
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid>
                            <Grid item xs={6}>
                                <Box
                                    style = {{backgroundColor: "white", 
                                            margin: 1,
                                            borderRadius: 15}}
                                >
                                    <Grid 
                                        container 
                                        spacing={0}
                                        justifyContent = "space-around"
                                        alignItems = "center"
                                        direction="row"
                                    >
                                        <Grid item xs={3}>
                                            {this.state.mode === 'Standard' && (
                                                <Box
                                                    style={{
                                                        backgroundColor: `rgb(${this.state.slid4}, 
                                                                                ${this.state.slid5},
                                                                                ${this.state.slid6})`,
                                                        borderRadius: 15,
                                                        border: '1px solid black',
                                                        minWidth: this.state.LBlocksOptions[this.state.renderType].clrBox1W,
                                                        minHeight: this.state.LBlocksOptions[this.state.renderType].clrBox1H,
                                                        margin: '5px',
                                                    }}
                                                />
                                            )}
                                        </Grid>
                                        <Grid item xs={this.state.mode === 'Standard' ? 9 : 12}>
                                            <Box 
                                                style = {{
                                                    paddingLeft: '8px', paddingRight: '8px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'center',
                                                    height: '60px',
                                                    margin: '10px',
                                                }}
                                            >
                                                <Slider
                                                    defaultValue={255}
                                                    aria-labelledby="discrete-slider"
                                                    valueLabelDisplay="auto"
                                                    value={this.state.slid4}
                                                    style={{
                                                        color:"rgb(255, 0, 0)", 
                                                        marginTop: '0px'
                                                    }}
                                                    step={1}
                                                    min={0}
                                                    max={this.state.mode === 'Standard' ? 255 : 50}
                                                    disabled={this.props.isDisabled}
                                                    onChange={(event, value) => this.handleSlider(event, value, 'slid4')}
                                                />
                                                <Slider
                                                    defaultValue={255}
                                                    aria-labelledby="discrete-slider"
                                                    valueLabelDisplay="auto"
                                                    value={this.state.slid5}
                                                    style={{
                                                        color:"rgb(0, 255, 0)", 
                                                        marginTop: '-10px'
                                                    }}
                                                    step={1}
                                                    min={0}
                                                    max={this.state.mode === 'Standard' ? 255 : 50}
                                                    disabled={this.props.isDisabled}
                                                    onChange={(event, value) => this.handleSlider(event, value, 'slid5')}
                                                />
                                                <Slider
                                                    defaultValue={255}
                                                    aria-labelledby="discrete-slider"
                                                    valueLabelDisplay="auto"
                                                    value={this.state.slid6}
                                                    style={{
                                                        color:"rgb(0, 0, 255)", 
                                                        marginTop: '-10px'
                                                    }}
                                                    step={1}
                                                    min={0}
                                                    max={this.state.mode === 'Standard' ? 255 : 50}
                                                    disabled={this.props.isDisabled}
                                                    onChange={(event, value) => this.handleSlider(event, value, 'slid6')}
                                                />
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid>
                            </Grid>
                        </Grid>
                        </Grid>
                    )}
                    {(this.state.renderType === 'imatrix') && (
                        <Grid 
                            container 
                            spacing={0}
                            className={classes.grid}
                            direction="row"
                        >
                        <Grid item xs={12}>
                            <Grid 
                                container 
                                spacing={0}
                                direction="row"
                            >
                            <Grid item xs={12} style={{position:'relative', top:'-35px',}}>
                                <Box display="flex" flexDirection="row-reverse">
                                <Button
                                    className={classes.textButton}
                                    style={{backgroundColor:this.state.LBlocksOptions[this.state.renderType].color}}
                                    variant="contained"
                                    onClick={(e) => this.handleMode(e, 'mode')}
                                    disabled={this.props.isDisabled}
                                >
                                    {this.state.mode}
                                </Button>
                                </Box>
                            </Grid>
                            <Grid item xs= {12} style = {{marginTop: '-30px'}}>
                                {(this.state.mode === 'Set String') && (
                                    <Grid 
                                        container 
                                        spacing={0}
                                        className={classes.grid}
                                        direction="row"
                                    >
                                    <Grid item xs="auto">
                                        <Typography 
                                            className={classes.regularText}
                                            style={{backgroundColor: this.state.LBlocksOptions[this.state.renderType].color}}
                                        >
                                            {this.state.LBlocksOptions[this.state.renderType].text1s}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs="auto">
                                        <Input 
                                            className={classes.inputField}
                                            name='in1'
                                            style={{
                                                width: this.state.LBlocksOptions[this.state.renderType].inWidth,
                                            }}
                                            inputProps={{
                                                style: { textAlign: 'center' }
                                            }}
                                            onChange = {this.handleIn}
                                            onBlur = {(e) => this.handleInOnBlur(e, 'in1')}
                                            value={this.state.in1}
                                            disabled={this.props.isDisabled}
                                            autoComplete="off"
                                        />
                                    </Grid>
                                    <Grid item xs="auto">
                                        <Typography 
                                            className={classes.regularText}
                                            style={{backgroundColor: this.state.LBlocksOptions[this.state.renderType].color}}
                                        >
                                            {this.state.LBlocksOptions[this.state.renderType].text2}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs="auto">
                                        <Button
                                            className={classes.textButton}
                                            style={{backgroundColor:this.state.LBlocksOptions[this.state.renderType].color}}
                                            variant="contained"
                                            onClick={() => this.handleBtn(1)}
                                            disabled={this.props.isDisabled}
                                        >
                                            {this.state.btn1Txt}
                                        </Button>
                                    </Grid>
                                    {this.state.btn1Txt === 'Scrolling' && (
                                        <React.Fragment>
                                        <Grid item xs="auto">
                                            <Typography 
                                                className={classes.regularText}
                                                style={{backgroundColor: this.state.LBlocksOptions[this.state.renderType].color}}
                                            >
                                                {this.state.LBlocksOptions[this.state.renderType].text3}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs="auto">
                                            <Input 
                                                className={classes.inputField}
                                                name='in2'
                                                style={{
                                                    width: this.state.LBlocksOptions[this.state.renderType].in2Width,
                                                }}
                                                inputProps={{
                                                    style: { textAlign: 'center' }
                                                }}
                                                onChange = {this.handleIn}
                                                onBlur = {(e) => this.handleInOnBlur(e, 'in2')}
                                                value={this.state.in2}
                                                disabled={this.props.isDisabled}
                                                autoComplete="off"
                                            />
                                        </Grid>
                                        <Grid item xs="auto">
                                            <Typography 
                                                className={classes.regularText}
                                                style={{backgroundColor: this.state.LBlocksOptions[this.state.renderType].color}}
                                            >
                                                {this.state.LBlocksOptions[this.state.renderType].text4}
                                            </Typography>
                                        </Grid>
                                        </React.Fragment>
                                    )}
                                    </Grid>
                                )}
                                {(this.state.mode === 'Set Brightness') && (
                                    <Grid item xs="auto">
                                        <Typography 
                                            className={classes.regularText}
                                            style={{backgroundColor: this.state.LBlocksOptions[this.state.renderType].color}}
                                        >
                                            {this.state.LBlocksOptions[this.state.renderType].text1b} {this.state.slid1}
                                        </Typography>
                                        <Slider
                                            defaultValue={3}
                                            aria-labelledby="discrete-slider"
                                            valueLabelDisplay="auto"
                                            value={this.state.slid1}
                                            style={{color:"rgb(255, 0, 0)", marginTop: '-20px'}}
                                            step={1}
                                            min={0}
                                            max={8}
                                            disabled={this.props.isDisabled}
                                            onChange={(event, value) => this.handleSlider(event, value, 'slid1')}
                                        />
                                    </Grid>
                                    
                                )}
                                {(this.state.mode === 'Clear Screen') && (
                                    <Typography 
                                        className={classes.regularText}
                                        style={{backgroundColor: this.state.LBlocksOptions[this.state.renderType].color}}
                                    >
                                        {this.state.LBlocksOptions[this.state.renderType].text1c}
                                    </Typography>
                                )}
                            </Grid>
                            </Grid>
                        </Grid>
                        </Grid>
                    )}


                </Box>
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(LocoHexBlocks);